var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_32759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71616 15.5437L4.34098 10.1685C3.73257 9.56011 3.73257 8.43989 4.34098 7.83148L9.71616 2.45631C10.3246 1.8479 11.4448 1.8479 12.0532 2.45631L17.4284 7.83148C18.0368 8.43989 18.0368 9.56011 17.4284 10.1685L12.0532 15.5437C11.4448 16.1521 10.3246 16.1521 9.71616 15.5437V15.5437Z",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88461 13.1719L7.24833 17.5356",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5209 17.5356L18.8846 13.1719",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_32759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.884644)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.25d4935d480b840fddbdcbf4cb453251.svg";
export { ForwardRef as ReactComponent };